import { baseApi } from "@/config/http-common";
import { filemanagerApi } from "@/config/http-filemanager";
import {
  DocumentReportExportPayload,
  DocumentReportParamConfig,
  ReportTemplate,
  SystemReportParamConfig,
} from "@/types/report/ReportTypes";

class ReportDataService {
  getDocumentReportList(
    params: DocumentReportParamConfig & { page?: number }
  ): Promise<any> {
    return baseApi.get("/reports/report/list", { params });
  }

  exportDocumentReport(payload: DocumentReportExportPayload): Promise<any> {
    return baseApi.post("/reports/report/export", payload, {
      responseType: "blob",
    });
  }

  createTemplate(data: ReportTemplate): Promise<any> {
    return baseApi.post("/reports/report/template/create", data);
  }

  getTemplateList(params: { page?: number }): Promise<any> {
    return baseApi.get("/reports/report/template/list", { params });
  }

  getTemplate(id: string): Promise<any> {
    return baseApi.get(`/reports/report/template/${id}`);
  }

  deleteTemplate(id: string): Promise<any> {
    return baseApi.delete(`/reports/report/template/delete/${id}`);
  }

  getSystemReportTypes(): Promise<any> {
    return baseApi.get("/reports/report/system/types");
  }

  getSystemReportConfig(type: number): Promise<any> {
    return baseApi.get("/reports/report/system/config", {
      params: { type },
    });
  }

  getSystemReportCategories(): Promise<any> {
    return baseApi.get("/reports/report/system/categories");
  }

  getSystemReportDirectorates(): Promise<any> {
    return baseApi.get("/reports/report/system/directorates");
  }

  getSystemReportRoles(): Promise<any> {
    return baseApi.get("/reports/report/system/roles");
  }

  getSystemReportProcessTypes(): Promise<any> {
    return baseApi.get("/reports/report/system/process-types");
  }

  previewSystemReport(payload: SystemReportParamConfig): Promise<any> {
    return baseApi.post("/reports/report/system/preview", payload);
  }

  exportSystemReport(payload: SystemReportParamConfig): Promise<any> {
    return baseApi.post("/reports/report/system/export", payload, {
      responseType: "blob",
    });
  }

  previewSystemReportFromTemplate(id: string): Promise<any> {
    return baseApi.get(`/reports/report/system/template/${id}`);
  }

  exportSystemReportFromTemplate(id: string): Promise<any> {
    return baseApi.get(`/reports/report/system/template/${id}/export`, {
      responseType: "blob",
    });
  }

  getUserReportList(params: { page?: number }): Promise<any> {
    return baseApi.get("/reports/report/user-report/list", { params });
  }

  downloadReport(fileGuid: string): Promise<any> {
    return filemanagerApi.get("/download", {
      params: { file: fileGuid, url: null },
      responseType: "blob",
    });
  }
}

export default new ReportDataService();
